import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const selectVideo = createAsyncThunk("selectVideo", async (data) => {
  try {
    const response = data;
    return response;
  } catch (error) {
    return error;
  }
});

export const videoView = createAsyncThunk(
  "videoView",
  async (postId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/post/view/${postId}/`);
      return response.data;
    } catch (error) {
      const errorPayload = error?.response?.data ?? { message: error.message || "Network Error" };
      console.error("Error:", errorPayload);
      return rejectWithValue(errorPayload);
    }
  }
);

export const SelectVideoView = createSlice({
  name: "SelectVideoView",
  initialState: {
    SelectedVideo: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    // AccountProfile action promises
    builder.addCase(selectVideo.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(selectVideo.fulfilled, (state, action) => {
      state.SelectedVideo = action.payload;
      state.loading = false;
    });
    builder.addCase(selectVideo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default SelectVideoView.reducer;
